// import { useState } from "react";
// import { motion } from "framer-motion";
// import { useSwipeable } from "react-swipeable";
// import icons from "../../../icons.config";
// import GlobalButton from "../../GlobalButton";
// import { setClickedItem } from "../../../store/itemsSlice";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { IMAGE_URL } from "../../../api-urls";

// const Trends = ({ data }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isFading, setIsFading] = useState(false);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handlers = useSwipeable({
//     onSwipedLeft: () => {
//       setIsFading(true);
//       setTimeout(() => {
//         setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
//         setIsFading(false);
//       }, 700);
//     },
//     onSwipedRight: () => {
//       setIsFading(true);
//       setTimeout(() => {
//         setCurrentIndex((prevIndex) => (prevIndex + totalImages - 1) % totalImages);
//         setIsFading(false);
//       }, 500);
//     },
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

//   if (!data || data.length === 0) return null;

//   const imagess = data[0]?.left?.data?.map((product) => ({
//     mainImage: product.default_variant?.mainImage,
//     product_name: product.product_name,
//     default_variant: product.default_variant,
//     product_category: product.product_category,
//   })) ?? [];

//   const totalImages = imagess.length;
//   const description = data[0]?.right?.data?.description;

//   const handleNext = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
//       setIsFading(false);
//     }, 700);
//   };

//   const handleBack = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + totalImages - 1) % totalImages);
//       setIsFading(false);
//     }, 500);
//   };

//   const imageVariants = {
//     center: { x: "0%", scale: 1, zIndex: 5, opacity: 1 },
//     right: { x: "50%", scale: 0.8, zIndex: 3, opacity: 0.5 },
//     left: { x: "-50%", scale: 0.8, zIndex: 3, opacity: 0.5 },
//     hidden: { opacity: 0, scale: 0.5, zIndex: 0 },
//   };

//   const getPosition = (index) => {
//     if (index === currentIndex) return "center";
//     if (index === (currentIndex + 1) % totalImages) return "right";
//     if (index === (currentIndex - 1 + totalImages) % totalImages) return "left";
//     return "hidden";
//   };

//   const handleDressClick = (item) => {
//     if (!item || !item.default_variant.id || !item.product_category?.length) {
//       console.error("Item is undefined or has missing properties");
//       return;
//     }

//     dispatch(setClickedItem(item));
//     const formatText = (text) => encodeURIComponent(text.replace(/\s+/g, ""));
//     const category = formatText(item.product_category[0].toLowerCase());
//     const productName = formatText(item.product_name);
//     const variant = formatText(item.default_variant.title);
//     const variantId = item.default_variant.id;

//     navigate(`/${category}/${productName}/${variant}/${variantId}/buy`);
//   };

//   const visibleItems = 1;
//   const numberOfDots = Math.ceil(totalImages / visibleItems);

//   const handleDotClick = (dotIndex) => {
//     setCurrentIndex(dotIndex * visibleItems);
//   };

 

//   return (
//     <section className="bg-tertiary overflow-hidden">
//       <div className="hidden lg:block relative lg:-right-0 lg:top-0 lg:left-[80%] xl:top-0 z-20">
//         <img src={icons.trendCircles} alt="Doodle Left" className="w-1/5" />
//       </div>
//       <div className="hidden lg:inline relative lg:left-[4%] bottom-40 z-20">
//         <img src={icons.collectionFlower} alt="Doodle Left" className="lg:w-24" />
//       </div>
//       <div className="lg:hidden relative -right-0 left-[60%] md:left-[62%] z-10">
//         <img src={icons.trendCircles} alt="Doodle Left" className="w-2/5 md:w-2/5" />
//       </div>
//       <div className="lg:hidden relative left-[5%] md:bottom-52 bottom-24 z-10">
//         <img src={icons.collectionFlower} alt="Doodle Left" className="w-16 md:w-20" />
//       </div>

//       <div
//         {...handlers}
//         className="bg-tertiary flex flex-col lg:flex-row py-[23%] md:pt-[2%] md:pb-[30%] lg:pb-0 lg:py-0 xl:pb-0 relative top-6 md:top-60 lg:-top-24 xl:-top-40 2xl:-top-44 z-10"
//       >
//         {/* Carousel Section */}
//         <h3 className="text-2xl md:text-4xl lg:hidden text-primary1 font-outfit font-light relative -top-48 md:-top-96 z-10 mb-20 text-center">
//           TREND WAVES
//         </h3>

//         <div className="bg-tertiary relative w-full lg:w-1/2 flex items-center justify-center bottom-0 overflow-hidden lg:left-11">
//           {/* Left Arrow */}
//           <img
//             src={icons.arrowLeft}
//             alt="left arrow"
//             className="absolute left-[8%] top-1/2 transform -translate-y-1/2 rounded-full h-11 w-11 z-20 cursor-pointer hidden lg:block p-1"
//             onClick={handleBack}
//           />

//           {/* Large Screen Carousel */}
          // <div className="hidden lg:block relative w-full h-screen  lg:left-[25%]">
          //   {imagess.map((item, index) => (
          //     <motion.div
          //       key={index}
          //       className="absolute transition-all duration-500 "
          //       style={{ width: "50%" }} // Sizing as per the provided snippet
          //       initial="hidden"
          //       animate={getPosition(index)}
          //       variants={imageVariants}
          //       transition={{ duration: 0.8 }}
          //     >
          //       <img
          //         src={IMAGE_URL + item.mainImage || "fallback-image.jpg"}
          //         title={item.product_name}
          //         className="hidden lg:block lg:h-screen object-cover py-12"
          //         alt={`Carousel ${item.product_name}`}
          //       />
          //       {/* Show "BUY" button on all images, not just the center */}
          //       <div className="absolute inset-0 bottom-10 bg-black bg-opacity-40 flex flex-col justify-end items-start p-6">
          //         <h3 className="text-lg lg:text-xl font-normal text-primary1">
          //           {item.product_name}
          //         </h3>
          //         <button
          //           className="py-1 px-4 mt-3 hover:text-hcolor font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500"
          //           onClick={() => handleDressClick(item)}
          //         >
          //           BUY
          //         </button>
          //       </div>
          //     </motion.div>
          //   ))}
          // </div>

//           {/* Small Screen Single Image */}
//           <motion.div
//             key={currentIndex}
//             className={`relative lg:hidden ${
//               isFading ? "opacity-0" : "opacity-100"
//             } transition-opacity duration-500`}
//             style={{ width: "79%" }}
//             initial="center"
//             animate="center"
//             transition={{ duration: 0.8 }}
//           >
//             <img
//               src={IMAGE_URL + imagess[currentIndex].mainImage || "fallback-image.jpg"}
//               title={imagess[currentIndex].product_name}
//               className="h-full w-full object-cover relative right-3"
//               alt={`Carousel ${imagess[currentIndex].product_name}`}
//             />
//             <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end items-start p-6">
//               <h3 className="text-lg font-normal text-primary1">
//                 {imagess[currentIndex].product_name}
//               </h3>
//               <button
//                 className="py-1 px-4 mt-3 hover:text-hcolor font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500"
//                 onClick={() => handleDressClick(imagess[currentIndex])}
//               >
//                 BUY
//               </button>
//             </div>
//           </motion.div>

//           {/* Right Arrow */}
//           <img
//             src={icons.arrowRight}
//             alt="right arrow"
//             className="absolute right-[2%] top-1/2 transform -translate-y-1/2 rounded-full h-11 w-11 z-20 cursor-pointer hidden lg:block p-1"
//             onClick={handleNext}
//           />
//         </div>

//         {/* Dot Indicators for Small Screens */}
//         <div className="flex justify-center pt-8 z-10 lg:hidden relative top-44 md:top-96 md:mb-12">
//           {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
//             <button
//               key={dotIndex}
//               onClick={() => handleDotClick(dotIndex)}
//               className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
//                 ${
//                   dotIndex === Math.floor(currentIndex / visibleItems)
//                     ? "bg-primary1"
//                     : "bg-white border border-primary1"
//                 } 
//                 shadow-lg`}
//             />
//           ))}
//         </div>

//         {/* Text Section */}
//         <div className="w-full lg:w-1/2 flex flex-col justify-center items-center lg:items-start lg:p-12 text-center lg:text-left relative lg:top-4 mt-56 md:mt-96 xl:h-screen lg:mt-0 lg:-right-0">
//           <h3 className="hidden lg:block lg:text-3xl text-primary1 font-outfit font-light relative bottom-24 lg:left-20">
//             TREND WAVES
//           </h3>
//           <h2 className="text-2xl lg:text- font-normal font-outfit text-primary1 px-3 relative bottom-7 lg:bottom-5 xl:bottom-8 left-0 lg:left-16 md:mb-6 lg:mb-0">
//             STAY AHEAD OF THE FASHION CURVE
//           </h2>
//           <p className="text-sm lg:text-base text-hcolor font-poppins font-light pr-8 pl-12 lg:px-20 text-start relative top-3">
//             {description}
//           </p>
//           <div className="flex justify-center mt-9 lg:pl-20 pb-4 relative lg:top-0 xl:top-20">
//             <GlobalButton
//               label="TRENDS"
//               routeName="shop"
//               className="border-2 py-3 px-7 flex bg-hcolor text-tertiary font-outfit font-medium hover:bg-tertiary hover:text-hcolor transition-all duration-500 ease-in-out"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Trends;
import { useState } from "react";
import { motion } from "framer-motion";
import { useSwipeable } from "react-swipeable";
import icons from "../../../icons.config";
import GlobalButton from "../../GlobalButton";
import { setClickedItem } from "../../../store/itemsSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../../../api-urls";

const Trends = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
        setIsFading(false);
      }, 700);
    },
    onSwipedRight: () => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + totalImages - 1) % totalImages);
        setIsFading(false);
      }, 500);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  if (!data || data.length === 0) return null;

  const imagess = data[0]?.left?.data?.map((product) => {
    const mediaUrl = product.default_variant?.mainImage;
    const isImage = mediaUrl ? /\.(jpg|jpeg|png|gif)$/i.test(mediaUrl) : true;
    return {
      mediaUrl,
      isImage,
      product_name: product.product_name,
      default_variant: product.default_variant,
      product_category: product.product_category,
    };
  }) ?? [];

  const totalImages = imagess.length;
  const description = data[0]?.right?.data?.description;

  const handleNext = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
      setIsFading(false);
    }, 700);
  };

  const handleBack = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + totalImages - 1) % totalImages);
      setIsFading(false);
    }, 500);
  };

  const imageVariants = {
    center: { x: "0%", scale: 1, zIndex: 5, opacity: 1 },
    right: { x: "50%", scale: 0.8, zIndex: 3, opacity: 0.5 },
    left: { x: "-50%", scale: 0.8, zIndex: 3, opacity: 0.5 },
    hidden: { opacity: 0, scale: 0.5, zIndex: 0 },
  };

  const getPosition = (index) => {
    if (index === currentIndex) return "center";
    if (index === (currentIndex + 1) % totalImages) return "right";
    if (index === (currentIndex - 1 + totalImages) % totalImages) return "left";
    return "hidden";
  };

  const handleDressClick = (item) => {
    if (!item || !item.default_variant.id || !item.product_category?.length) {
      console.error("Item is undefined or has missing properties");
      return;
    }

    dispatch(setClickedItem(item));
    const formatText = (text) => encodeURIComponent(text.replace(/\s+/g, ""));
    const category = formatText(item.product_category[0].toLowerCase());
    const productName = formatText(item.product_name);
    const variant = formatText(item.default_variant.title);
    const variantId = item.default_variant.id;

    navigate(`/${category}/${productName}/${variant}/${variantId}/buy`);
  };

  const visibleItems = 1;
  const numberOfDots = Math.ceil(totalImages / visibleItems);

  const handleDotClick = (dotIndex) => {
    setCurrentIndex(dotIndex * visibleItems);
  };

  const goToShop = () => {
    navigate("/shop");
  };

  return (
    <section className="bg-tertiary overflow-hidden">
      <div className="hidden lg:block relative lg:-right-0 lg:top-0 lg:left-[80%] xl:top-0 z-20">
        <img src={icons.trendCircles} alt="Doodle Left" className="w-1/5" />
      </div>
      <div className="hidden lg:inline relative lg:left-[4%] bottom-40 z-20">
        <img src={icons.collectionFlower} alt="Doodle Left" className="lg:w-24" />
      </div>
      <div className="lg:hidden relative -right-0 left-[60%] md:left-[62%] z-10">
        <img src={icons.trendCircles} alt="Doodle Left" className="w-2/5 md:w-2/5" />
      </div>
      <div className="lg:hidden relative left-[5%] md:bottom-52 bottom-24 z-10">
        <img src={icons.collectionFlower} alt="Doodle Left" className="w-16 md:w-20" />
      </div>

      <div
        {...handlers}
        className="bg-tertiary flex flex-col lg:flex-row py-[23%] md:pt-[2%] md:pb-[30%] lg:pb-0 lg:py-0 xl:pb-0 relative top-6 md:top-60 lg:-top-24 xl:-top-40 2xl:-top-44 z-10"
      >
        {/* Carousel Section */}
        <h3 className="text-3xl md:text-4xl lg:hidden text-primary1 font-outfit font-light relative -top-40 md:-top-96 z-10 md:mb-20 text-center">
          TREND WAVES
        </h3>

        <div className="bg-tertiary relative w-full lg:w-1/2 flex items-center justify-center bottom-0 ">
          {/* Left Arrow */}
          <img
            src={icons.arrowLeft}
            alt="left arrow"
            className="absolute left-[8%] xl:left-[12%] 2xl:left-[14%] top-1/2 transform -translate-y-1/2 rounded-full h-11 w-11 z-20 cursor-pointer hidden lg:block p-1"
            onClick={handleBack}
          />

          {/* Large Screen Carousel */}
          <div className="hidden lg:block relative w-full h-screen  left-[35%] 2xl:left-[37%]">
            {imagess.map((item, index) => (
              <motion.div
                key={index}
                className="absolute transition-all duration-500 "
                style={{ width: "50%" }} // Sizing as per the provided snippet
                initial="hidden"
                animate={getPosition(index)}
                variants={imageVariants}
                transition={{ duration: 0.8 }}
              >
                {item.isImage ? (
                  <img
                    src={IMAGE_URL + item.mediaUrl || "fallback-image.jpg"}
                    title={item.product_name}
                    className="hidden lg:block  lg:h-screen object-cover xl:py-12"
                    alt={`Carousel ${item.product_name}`}
                  />
                ) : (
                  <video
                    className="hidden lg:block lg:h-screen object-cover py-12"
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source src={IMAGE_URL + item.mediaUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                {/* Show "BUY" button on all images, not just the center */}
                <div className="absolute inset-0 bottom-10 bg-black bg-opacity-40 flex flex-col justify-end items-start p-6">
                  <h3 className="text-lg lg:text-xl font-normal text-primary1">
                    {item.product_name}
                  </h3>
                  <button
                    className="py-1 px-4 mt-3 hover:text-hcolor font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500"
                    onClick={() => handleDressClick(item)}
                  >
                    BUY
                  </button>
                </div>
              </motion.div>
            ))}
          </div>


          {/* Small Screen Single Image */}
          <motion.div
            key={currentIndex}
            className={`relative lg:hidden ${
              isFading ? "opacity-0" : "opacity-100"
            } transition-opacity duration-500  h-[500px] left-4`}
            style={{ width: "79%" }}
            initial="center"
            animate="center"
            transition={{ duration: 0.8 }}
          >
            {imagess[currentIndex].isImage ? (
              <img
                src={IMAGE_URL + imagess[currentIndex].mediaUrl || "fallback-image.jpg"}
                title={imagess[currentIndex].product_name}
                className="h-full w-full object-cover relative right-3"
                alt={`Carousel ${imagess[currentIndex].product_name}`}
              />
            ) : (
              <video
                className="h-full w-full object-cover relative right-3"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src={IMAGE_URL + imagess[currentIndex].mediaUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end items-start p-6">
              <h3 className="text-lg font-normal text-primary1">
                {imagess[currentIndex].product_name}
              </h3>
              <button
                className="py-1 px-4 mt-3 hover:text-hcolor font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500"
                onClick={() => handleDressClick(imagess[currentIndex])}
              >
                BUY
              </button>
            </div>
          </motion.div>

          {/* Right Arrow */}
          <img
            src={icons.arrowRight}
            alt="right arrow"
            className="absolute right-[2%] xl:-right-[8%] 2xl:-right-[10%] top-1/2 transform -translate-y-1/2 rounded-full h-11 w-11 z-50 cursor-pointer hidden lg:block p-1"
            onClick={handleNext}
          />
        </div>

        {/* Dot Indicators for Small Screens */}
        <div className="flex justify-center my-10 z-10 lg:hidden relative  md:mb-12">
          {Array.from({ length: numberOfDots }).map((_, dotIndex) => (
            <button
              key={dotIndex}
              onClick={() => handleDotClick(dotIndex)}
              className={`w-2 h-2 md:h-3 md:w-3 mx-2 rounded-full 
                ${
                  dotIndex === Math.floor(currentIndex / visibleItems)
                    ? "bg-primary1"
                    : "bg-white border border-primary1"
                } 
                shadow-lg`}
            />
          ))}
        </div>

        {/* Text Section */}
        <div className="w-full lg:w-1/2 flex flex-col justify-between lg:p-12 text-center lg:text-left relative xl:h-screen">
          {/* Removed lg:top-4, mt-56, md:mt-96, lg:mt-0, lg:-right-0 */}
          <div>
            <h3 className="hidden lg:block lg:text-5xl text-primary1 font-outfit font-light relative lg:left-20">
              {/* Removed bottom-24, lg:left-20 */}
              TREND WAVES
            </h3>
            <h2 className="text-3xl lg:text- font-normal font-outfit text-primary1 px-3 relative bottom-7 lg:bottom-5 xl:bottom-8 left-0 lg:left-16 md:mb-6 lg:mb-0 lg:mt-20">
              STAY AHEAD OF THE FASHION CURVE
            </h2>
            <p className="text-sm lg:text-base text-hcolor font-poppins font-light pr-8 pl-12 lg:px-20 text-start relative top-3">
              {description}
            </p>
          </div>
          <div className="flex justify-center lg:justify-start lg:pl-20 mt-9 lg:mt-0 pb-4">
            {/* Removed lg:top-0, xl:top-20 */}
            <GlobalButton
              label="TRENDS"
              routeName="shop"
              className="border-2 py-3 px-7 flex bg-hcolor text-tertiary font-outfit font-medium hover:bg-tertiary hover:text-hcolor transition-all duration-500 ease-in-out"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trends;